import { render, staticRenderFns } from "./activity_order_sel_page.vue?vue&type=template&id=c9240642"
import script from "./activity_order_sel_page.vue?vue&type=script&lang=js"
export * from "./activity_order_sel_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9240642')) {
      api.createRecord('c9240642', component.options)
    } else {
      api.reload('c9240642', component.options)
    }
    module.hot.accept("./activity_order_sel_page.vue?vue&type=template&id=c9240642", function () {
      api.rerender('c9240642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/components/activity_order_sel_page.vue"
export default component.exports